export interface TrustFieldsRequestInfo {
    incomePercent: number;
    principalPercent: number;
    paidForContact: PaidForDetails;
    settlementDate: string;
    tradeDate: string;
    taxCode: string;
    comment: string;
    accountNumber?: string;
    accountName?: string;
    accountType?: string;
    financialInstitution?: string;
    aba?: string;
    toAccount?: string;
    transactionCode: string;
}

export class PaidForDetails {
    id: number = -1;
    name: string = 'Paid For The Trust';
    role: string = 'Owner';
}